import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import CourseVideo from '../Courses/CourseVideo'
import videoImg from "../../../assets/images/courses/courses-1.jpg"


const GetStarted = () => {
    return (
        <>

            <Bredcrum
                heading={'Getting ready to learn to drive'}
                path={[
                    { name: 'get started', path: 'get-started' },
                ]}
            />

            <div className=' my-5'>
                <div className='auto-container p-md-5 p-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div >
                        <div className="sec-title ">
                            <div>
                                <h3 className='mb-4 fs-2 fw-semibold'>Getting Started</h3>

                                <p className='d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                    You can begin getting ready for your hypothesis test straight away by downloading our free preliminary hypothesis test applications for your brilliant gadget, PC or planning utilizing our web based learning center point. Nonetheless, you can't begin your driving examples until you have a temporary driving permit. You can get a temporary driving permit direct by utilizing the 
                                        <a href="https://motoring.dvla.gov.uk/service/DvoConsumer.portal?_nfpb=true&amp;_pageLabel=FAP&amp;_nfls=false" className="text-green" rel="noopener nofollow" target="_blank" title="DVLA online Provisional licence application"> DVLA online temporary permit application.</a>.
                                    </div>
                                </p>
                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    You can apply for your provisional driving licence from the age of 15 years and 9 months. You must also be able to read a number plate from 20 metres away (with or without glasses).
                                </p>
                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <span>For further information regarding eyesight rules visit <br/> <a href="https://www.gov.uk/driving-eyesight-rules" rel="noopener nofollow" className="text-green" target="_blank" title="Driving eyesight rules">   www.gov.uk/driving-eyesight-rules </a></span>
                                </p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

            {/* <CourseVideo bgImage={videoImg} /> */}

            <div className=' my-5'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div >
                        <div className="sec-title ">
                            <div  >
                                <h3 className='mb-4 fs-3 fw-semibold'>How to apply for your provisional driving licence</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        The quickest way to apply fro your provisional driving licence is online by visiting <a href="https://www.gov.uk/apply-first-provisional-driving-licence" rel="noopener nofollow" className="text-green" target="_blank" title="Driving eyesight rules">   www.gov.uk/apply-first-provisional-driving-licence. </a> The current cost online is £34. Alternatively you can collect a D1 from from your local post office.
                                    </div>
                                </p>
                            </div>

                            <div className='mt-5'>
                                <h3 className='mb-4 fs-3 fw-semibold'>You can start driving before booking or passing your Theory Test</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        You can start your driving lessons as soon as your learner's licence expires, but you cannot book your driving test until you have passed your theory test. You should be able to book your theory test  a few days in advance and receive your test result on the day of the test. With your learner's licence, you can book your theory test  on or shortly after your 17th birthday. The waiting time for a driving test is usually 6 to 10 weeks. You can usually book an earlier appointment by cancelling your test booking.
                                    </div>
                                </p>
                            </div>

                            <div className='mt-5'>
                                <h3 className='mb-4 fs-3 fw-semibold'>How to book your Theory Test online</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        We can book your theory test for a small administration fee or you can book direct on the Governments  <a href="https://www.gov.uk/book-theory-test" rel="noopener nofollow" className="text-green" target="_blank" title="Driving eyesight rules"> online theory test booking service.</a> The current charge is £23.
                                    </div>
                                </p>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        With a valid learner's license, you can start your driving lessons before taking your written test. This means that you can combine your theoretical learning with the first part of your driving course. This also gives you the added benefit of being able to consult your driving instructor for various questions regarding your theory test and your theoretical learning. Once you have passed your theory test, your driving instructor can book your driving test and plan the remainder of your driving lessons.

                                    </div>
                                </p>
                            </div>

                            <div className='mt-5'>
                                <h3 className='mb-4 fs-3 fw-semibold'>How to book your Driving Test online</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        We can book your driving test for a small administration fee (free if you buy a course with us) or you can book direct on the Governments  <a href="https://www.gov.uk/book-practical-driving-test" rel="noopener nofollow" className="text-green" target="_blank" title="Driving eyesight rules"> online driving test booking service</a>.
                                    </div>
                                </p>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        From the above you can see that learning to drive can be achieved quickly. However, it is important to book your course in advance to ensure you get the desired lessons and test dates. Our staff can advise and assist you in choosing the right training course.
                                    </div>
                                </p>
                            </div>

                            <div className='mt-5'>
                                <h3 className='mb-4 fs-3 fw-semibold'>Proving Your Entitlement to Drive</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        Endorsements, penalty points and driving bans will no longer be recorded on driving licences, but will instead only be accessible online.
                                    </div>
                                </p>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        For insurance purposes, before your first driving lesson your Instructor is required to check your full licence details to see the vehicles you’re allowed to drive, and to check for penalty points and disqualifications.
                                    </div>
                                </p>
                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        The consequences for not checking the above are very serious and this procedure is in place to protect you, your instructor and the general public. See next section below for details of how to do this.
                                    </div>
                                </p>
                            </div>

                            <div className='mt-5'>
                                <h3 className='mb-4 fs-3 fw-semibold'>Before your first driving lesson you must do the following</h3>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        You’ll need to generate a code which will allow your instructor to check your licence details:
                                    </div>
                                </p>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    You will need
                                </p>

                                <div className='my-4'>
                                    <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                        <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green bg-white"></i>
                                        Your driving licence
                                    </p>
                                    <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                        <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green bg-white"></i>
                                        Your national insurance number
                                    </p>
                                    <p className='align-items-center d-flex mb-2 fw-bold lh-sm'>
                                        <i className="bi bi-check-lg px-2 fs-4 py-1 me-3 text-green bg-white"></i>
                                        Your home postcode
                                    </p>
                                </div>

                                <p>
                                    Go to this website : <a href="https://www.gov.uk/view-driving-licence
                                " className='text-green'>https://www.gov.uk/view-driving-licence</a>
                                </p>

                                <ol start={1} className='mt-4 ' style={{ listStyle: 'initial' }}>
                                    <li className='d-flex mb-2'><b className='me-1' style={{minWidth: '80px'}}>Step one: </b>enter your driving licence number, national insurance number and postcode as shown on your driving licence.</li>

                                    <li className='d-flex mb-2'><b className='me-1' style={{minWidth: '80px'}}>Step two: </b>
                                    click on “share licence information”. This creates a code. The code is case sensitive, can only be used once, and is only valid for 21 days.</li>

                                    <li className='d-flex mb-2'><b className='me-1' style={{minWidth: '80px'}}>Step three: </b>pass the code to your Instructor together with the last eight digits of your driving licence number.</li>
                                </ol>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <div>
                                        In advance of your first driving lesson your Instructor will view your licence details online. Be aware that your Instructor may save a screenshot as evidence of the licence entitlement check.
                                    </div>
                                </p>

                                <p className='mt-3 d-flex'>
                                    <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                    <b>
                                    Please note you should also produce your photo card licence for ID inspection on your first lesson. It is your responsibility to provide your Instructor with proof that you have a valid licence to drive, before the commencement of your first lesson. If you fail to provide this proof, your Instructor is entitled to refuse to conduct the lesson but still charge you.
                                    </b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default GetStarted